import React from 'react';
import clsx from 'clsx';
import CheckboxSmall, { CheckboxSize } from 'components/Checkbox/CheckboxSmall';

import styles from './ToggleButton.module.scss';

export enum ToggleButtonType {
  Radio = 'radio',
  Checkbox = 'checkbox',
}

interface ToggleButtonProps<T> {
  title: string;
  value: T;
  selected?: boolean;
  description?: string;
  type: ToggleButtonType;
  onClick: (value: T) => void;
}

const ToggleButton = <T,>({ title, value, selected = false, description, type, onClick }: ToggleButtonProps<T>) => (
  <div
    className={clsx(styles.toggleButton, selected && styles.selected)}
    onClick={(event) => {
      event.stopPropagation();
      onClick(value);
    }}
    data-value={value}
  >
    <div className={styles.content}>
      <div className={styles.title}>{title}</div>
      {description && <div className={styles.description}>{description}</div>}
    </div>
    <div className={styles.control}>
      {type === 'radio' ? (
        <span className={styles.radioControl}>{selected && <span className={styles.radioSelected} />}</span>
      ) : (
        <div onClick={(e) => e.stopPropagation()}>
          <CheckboxSmall
            checked={selected}
            onChange={() => onClick(value)}
            size={CheckboxSize.Sm}
            checkboxLabelClassName={styles.checkboxLabel}
          />
        </div>
      )}
    </div>
  </div>
);

export default ToggleButton;
